export const parseConfig = {
    // URL: "http://52.66.243.78:1337/parse",
    // URL: "https://game-admin-server.onrender.com/parse",
    URL: "http://localhost:1338/parse",
    JAVASCRIPT_KEY: null,
    APP_ID: "getWaysAppDev",
    MASTER_KEY: "-9VRI+8B=z_MaterKe",
};
